<template>
  <div class="my-2">
    <p class="text-sm-center text-secondary">{{ title }}</p>
    <hr class="w-100 m-0">
  </div>
</template>

<script>
export default {
  name: "LineSeparator",
  props : {
    title : {
      default : '',
      type : String,
    }
  }
}
</script>

<style lang="scss" scoped>
hr {
  border: 1px solid var(--grid-lines);
  transition: var(--transition-default);
}

p {
  height: 7px;
  color: var(--text-secondary);
  font-size: var(--font-size-captions);
  font-weight: var(--font-weight-body);
}
</style>